<template>
<b-container v-if="infoContact.id" class="px-0">
    <b-row class="justify-content-md-center">
        <b-col cols=12>
            <b-card no-body tag="h1" class="border-0 pt-3 pb-3 bg-transparent">{{infoContact.nume_pagina}}
            </b-card>
        </b-col>
    </b-row>
    <b-row>
        <b-col cols=12>
            <b-card class="shadow p-1 mb-4 rounded bg-transparent">
                <b-card-text v-html="infoContact.continut_pagina"></b-card-text>
            </b-card>
        </b-col>
    </b-row>
</b-container>
<b-container v-else>
    <b-row>
        <b-col slot="spinner">Se încarcă...</b-col>
    </b-row>
</b-container>
</template>

<script>

export default {
    data() {
        return {
            infoContact: {},
        };
    },
    methods: {
        getArticles() {
            fetch("https://app.bibliotecaarad.ro/backend/api/pagina/" + this.$route.params.id)
                .then(response => response.json())
                .then(data => this.infoContact = data);
        }
    },
    created() {
        this.getArticles();
    }
};
</script>
